module.exports = __webpack_public_path__ + "2866d1757023a8cd57618fb5fa0ed1e9.png";